import { render, staticRenderFns } from "./MsgList.vue?vue&type=template&id=e36c2e4e&scoped=true"
import script from "./MsgList.vue?vue&type=script&lang=js"
export * from "./MsgList.vue?vue&type=script&lang=js"
import style0 from "./MsgList.vue?vue&type=style&index=0&id=e36c2e4e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36c2e4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e36c2e4e')) {
      api.createRecord('e36c2e4e', component.options)
    } else {
      api.reload('e36c2e4e', component.options)
    }
    module.hot.accept("./MsgList.vue?vue&type=template&id=e36c2e4e&scoped=true", function () {
      api.rerender('e36c2e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/MsgList.vue"
export default component.exports